import {cva} from 'class-variance-authority'

/**
 * Card surface (v3 "Card/Default"): a `background-default` content surface (white)
 * with a 4px radius and 8px padding. Using the token keeps the surface opaque over
 * a tinted container rather than inheriting it. `outline` adds the 1px divider border; `elevated` gives the
 * persistent `elevation-1` shadow (the Figma "Hover" state); `interactive`
 * raises that same shadow on hover for clickable cards. The three axes are
 * independent and compose freely.
 */
export const CardVariantsFactory = cva('flex min-h-20 w-full flex-col rounded bg-background p-2', {
  variants: {
    outline: {
      true: 'border border-divider',
      false: '',
    },
    elevated: {
      true: 'shadow-elevation-1',
      false: '',
    },
    interactive: {
      true: 'cursor-pointer transition-shadow hover:shadow-elevation-1',
      false: '',
    },
  },
  defaultVariants: {outline: false, elevated: false, interactive: false},
})
